var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[(!_vm.shouldLoadCss)?_c('router-view'):_vm._e(),_c('DimmedArea')],1)}
var staticRenderFns = []

export { render, staticRenderFns }